import { IconNames } from "@repo/core/components/core/Icon/types";
import { CardCollapseVariant } from "./types";

export const CardCollapseVariantsThemeMap: Record<
  CardCollapseVariant,
  { icon: IconNames; iconColor: string; borderColor: string }
> = {
  [CardCollapseVariant.error]: {
    icon: "times-circle",
    iconColor: "$error600",
    borderColor: "$error100",
  },
  [CardCollapseVariant.success]: {
    icon: "check-circle",
    iconColor: "$primary700",
    borderColor: "$success100",
  },
};
